import { useEffect, useRef, useState } from "react";
import { ConvertToFloat, isValidArray } from "../../../Layout/Common/common";

import { OrderCartItemSkeleton } from "../../../Skeleton/orderViewSkeleton";
import { useAuth } from "../../../Context/AuthContext";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { LoadMoreCartItem } from "../../../Layout/Common/cartItemDynamicLoad";
import { PendingOrderItemRow } from "./pendingOrderItemRow";

export const PendingOrderItemList = ({ items, orderId, onUpdate }) => {
  const [orderItem, setOrderItem] = useState();
  const [cartItem, setCartItem] = useState([]);
  const [totalCartItem, setTotalCartItem] = useState(0);
  useEffect(() => {
    if (items) {
      setOrderItem(items);
      setTotalCartItem(items.totalItem);
      setCartItem(items.cartItem);
    }
  }, [items]);

  return (
    <div className="col-lg-12 mt-3 mt-md-4 billingShipping-wrapper">
      {/* Order Items */}
      <div className="order-address">
        <div className="card order-address-card">
          <div className="card-header">
            <h5>
              <span className="wes wes-download" />
              Order Items
            </h5>
          </div>
          {cartItem && isValidArray(cartItem) ? (
            <div className="card-body order-address-body">
              <div className="row">
                <div className="col-md-8 col-lg-8 col-sm-12 col-xs-12 ">
                  <div className="order-summary-details mt-0">
                    {cartItem.map((row, index) => (
                      <PendingOrderItemRow
                        key={row.prod_id ?? index}
                        row={row}
                        index={index}
                        onSyncUpdate={onUpdate}
                        isLastItem={cartItem.length === 1}
                      />
                    ))}
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                  {orderItem && isValidArray(cartItem) && (
                    <div className="order-summary-details  mt-0">
                      <div className="order-prices">
                        <div className="order-prices-list">
                          <p>Sub Total</p>
                          <span>$ {orderItem && ConvertToFloat(orderItem.totalcost)}</span>
                        </div>
                        <div className="order-prices-list">
                          <p> Shipping</p>
                          <span>$ {orderItem && ConvertToFloat(orderItem.shipcost)}</span>
                        </div>
                        <div className="order-prices-list">
                          <p>Tax Amount</p>
                          <span>$ {orderItem && ConvertToFloat(orderItem.totaltax)}</span>
                        </div>
                        <div className="order-prices-list" style={{ display: "none" }}>
                          <p>Freight</p>
                          <span>TBA</span>
                        </div>
                      </div>
                      <div className="order-prices-list order-prices-total" style={{ fontWeight: "bold" }}>
                        <p>Total</p>
                        <span>$ {orderItem && ConvertToFloat(orderItem.totalIncTax)}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <OrderCartItemSkeleton />
          )}
        </div>
      </div>
      {/* Order Items */}
    </div>
  );
};
